import { render, staticRenderFns } from "./dashboard-progress-block-component.vue?vue&type=template&id=5c518c1e&scoped=true&"
import script from "./dashboard-progress-block-component.vue?vue&type=script&lang=ts&"
export * from "./dashboard-progress-block-component.vue?vue&type=script&lang=ts&"
import style0 from "./dashboard-progress-block-component.vue?vue&type=style&index=0&id=5c518c1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c518c1e",
  null
  
)

export default component.exports